// Keep in sync with APP PowerBankProtocol.parseExceptionInfoData:
// Continue(1B) + N * [Timestamp(4B, LE) + Code(1B) + CodeData].
// Uploads contain the 0x2E Data Array, without the protocol frame or CRC.
export function parsePowerBankException (rawData) {
  if (typeof rawData !== 'string') return null
  const hex = rawData.replace(/\s/g, '')
  if (!/^(?:[0-9a-fA-F]{2})+$/.test(hex)) return null
  const bytes = Uint8Array.from(hex.match(/../g), byte => parseInt(byte, 16))
  if (bytes[0] > 1) return null

  const view = new DataView(bytes.buffer)
  const units = []
  let offset = 1
  while (offset < bytes.length) {
    if (bytes.length - offset < 5) return null
    const timestampSeconds = view.getUint32(offset, true)
    const code = bytes[offset + 4]
    offset += 5

    if (code === 0xD5) {
      if (offset >= bytes.length) return null
      const cellCount = bytes[offset]
      const payloadLength = 1 + cellCount * 2
      if (bytes.length - offset < payloadLength) return null
      const cellVoltagesMv = Array.from({ length: cellCount }, (_, index) => {
        const value = view.getUint16(offset + 1 + index * 2, true)
        return value === 0xFFFF ? null : value
      })
      units.push({ timestampSeconds, code, cellVoltagesMv })
      offset += payloadLength
    } else if (code === 0xD6) {
      if (bytes.length - offset < 3) return null
      units.push({
        timestampSeconds,
        code,
        chargeDischargeState: bytes[offset],
        temperatureCelsius: view.getInt16(offset + 1, true) * 0.1
      })
      offset += 3
    } else {
      // Unknown codes have no shared length field; do not guess boundaries
      // or display a partially decoded packet as a successful result.
      return null
    }
  }
  return { hasMore: bytes[0] === 1, units }
}
